<div class="timeline-scale-tick" [style.left.px]="positionInPixels">{{position | seconds}}</div>



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-scale/timeline-scale-tick/timeline-scale-tick.component.html